/**
 * @description Throws an error if the value is null or undefined
 * @param value - The value to check
 * @param message - The message to throw
 * @param safe - If true, the error will not be thrown but logged
 */
export const throwIfNil = (value: any, message: string, safe?: boolean) => {
  if (value === null || value === undefined) {
    const error = new NilError(message);
    if (!safe) {
      throw error;
    }
    console.error(error);
  }
};

export class NilError extends Error {
  constructor(message: string) {
    super(message);
    this.name = `NilError`;
  }
}

export const throwIfEmpty = (value: any, message: string, safe?: boolean) => {
  if (value === null || value === undefined || value === ``) {
    const error = new EmptyError(message);
    if (!safe) {
      throw error;
    }
    console.error(error);
  }
};

export class EmptyError extends Error {
  constructor(message: string) {
    super(message);
    this.name = `EmptyError`;
  }
}

export const logOrThrow = (msg: string, safe?: boolean) => {
  if (safe) {
    console.error(msg);
  } else {
    throw new Error(msg);
  }
};
